import type { ReactNode } from "react";

interface Props {
  title?: ReactNode;
  subtitle?: ReactNode;
  leading?: ReactNode;
  trailing?: ReactNode;
  transparent?: boolean;
}

export function MaTopBar({ title, subtitle, leading, trailing, transparent = false }: Props) {
  return (
    <div style={{
      position: "relative", zIndex: 5,
      paddingTop: "calc(env(safe-area-inset-top, 20px) + 34px)",
      paddingLeft: 16, paddingRight: 16, paddingBottom: 12,
      background: transparent ? "transparent" : "var(--ma-paper)",
      display: "flex", alignItems: "flex-end", gap: 12,
    }}>
      {leading}
      <div style={{ flex: 1, minWidth: 0 }}>
        {subtitle && (
          <div className="ma-mono" style={{ fontSize: 10, letterSpacing: "0.18em",
            textTransform: "uppercase", color: "var(--ma-ink-soft)", marginBottom: 4 }}>
            {subtitle}
          </div>
        )}
        {title && (
          <div className="ma-display" style={{ fontSize: 30, color: "var(--ma-ink)" }}>
            {title}
          </div>
        )}
      </div>
      {trailing}
    </div>
  );
}
